import React, { memo } from 'react';
import { useSidebar } from '../../contexts/SidebarContext';

import styles from './styles/ContentArea.module.css';

const ContentArea = ({ children }) => {
    const { isSidebarCollapsed } = useSidebar();

    return (
        <div className={`${styles.contentArea} ${isSidebarCollapsed ? styles.expanded : ''}`}>
            {children}
        </div>
    );
};

export default memo(ContentArea);
